import React from 'react';
import styles from './CloseJobModal.module.css';

interface CloseJobModalProps {
  isOpen: boolean;
  jobTitle: string;
  acceptedCount: number;
  onClose: () => void;
  onConfirm: () => void;
}

const CloseJobModal: React.FC<CloseJobModalProps> = ({
  isOpen,
  jobTitle,
  acceptedCount,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className={styles.overlay} onClick={onClose} data-testid="close-job-modal-overlay" />
      <div className={styles.modal} onClick={(e) => e.stopPropagation()} data-testid="close-job-modal">
        <div className={styles.header}>
          <h2 className={styles.title}>Close Job Posting</h2>
          <button className={styles.close} onClick={onClose} data-testid="close-job-modal-close">
            ×
          </button>
        </div>
        <div className={styles.content}>
          <p className={styles.message}>
            Are you sure you want to close the job posting for <strong>{jobTitle}</strong>?
          </p>
          <div className={styles.info}>
            <div className={styles.infoItem}>
              <span className={styles.infoLabel}>Accepted Candidates:</span>
              <span className={styles.infoValue}>{acceptedCount}</span>
            </div>
          </div>
          <p className={styles.warning}>⚠️ Closing this job will:</p>
          <ul className={styles.warningList}>
            <li>Mark the job as "Filled" on your dashboard</li>
            <li>Stop receiving new applications</li>
            <li>Move the job to "Filled / Archived" section</li>
          </ul>
        </div>
        <div className={styles.footer}>
          <button className={styles.buttonSecondary} onClick={onClose} data-testid="close-job-cancel">
            Cancel
          </button>
          <button className={styles.buttonPrimary} onClick={onConfirm} data-testid="close-job-confirm">
            Close Job
          </button>
        </div>
      </div>
    </>
  );
};

export default CloseJobModal;
